import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

const LINKS = [
  { to: "/shop", label: "Shop" },
  { to: "/collection", label: "The Collection" },
  { to: "/journaling", label: "How It Helps" },
  { to: "/bundle", label: "Caregiver Bundle" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-ink/10 bg-white">
      <div className="mx-auto max-w-7xl px-5 py-14 sm:px-8 lg:py-20">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-ink-soft">
              Know your health. Know your questions. Know your next step.
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-ink-faint">Explore</p>
            <ul className="mt-4 space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.slice(1)}`}
                    className="text-sm font-semibold text-ink-soft transition-colors hover:text-lav-deep"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-ink-faint">Our promise</p>
            <p className="mt-4 text-sm leading-relaxed text-ink-soft">
              A patient healthcare journal that complements your care team, your patient portal, and your
              doctor—never a replacement for them.
            </p>
          </div>
        </div>
        <div className="mt-14 border-t border-ink/5 pt-6">
          <p className="text-xs leading-relaxed text-ink-faint" data-testid="footer-disclaimer">
            In Your Corner Healthcare is a personal healthcare organization and advocacy tool. It
            complements—not replaces—MyChart, patient portals, medical records, or professional medical advice.
            If you have concerns about your health, please speak with a qualified professional.
          </p>
          <p className="mt-3 text-xs text-ink-faint">
            © 2026 In Your Corner Healthcare. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
